export const ALL_CURRENCIES = [
  { id: "USD", name: "US Dollar" },
  { id: "EUR", name: "Euro" },
  { id: "GBP", name: "British Pound" },
  { id: "AED", name: "UAE Dirham" },
  { id: "AUD", name: "Australian Dollar" },
];

export const SUPPORTED_CURRENCY_IDS = ALL_CURRENCIES.map(({ id }) => id);

export const isSupportedCurrency = (currency) => SUPPORTED_CURRENCY_IDS.includes((currency || "").toUpperCase());
